class Rating {
  constructor() {
    this.ratingEls = document.querySelectorAll(".jsRating");
    this.ratingActionEl = document.getElementById("jsRatingAction");
    this.pointEl = document.getElementById("jsPoint");
    this.init();
  }

  init() {
    if (this.ratingEls.length > 0) {
      this.ratingEls.forEach((ratingEl) => {
        this.create(ratingEl);
      });
    }
    if (this.ratingActionEl) {
      this.ratingSelectedEls = this.ratingActionEl.querySelectorAll("span");
      this.ratingVauleEl = this.ratingActionEl.querySelector("input");
      if (this.ratingSelectedEls.length > 0) {
        this.action();
      }
    }
  }

  create(el) {
    for (let i = 0; i < 5; i++) {
      let spanEl = document.createElement("span");
      if (i < Math.round(el.dataset.point)) {
        spanEl.dataset.type = "point";
      }
      el.append(spanEl);
    }
  }

  action() {
    this.ratingSelectedEls.forEach((ratingEl) => {
      this.click(ratingEl);
    });
  }

  click(el) {
    el.addEventListener("click", (e) => {
      this.ratingVauleEl.value = el.dataset.point;
      this.ratingVauleEl.dataset.point = el.dataset.point;
      this.pointEl.value = el.dataset.point;
    });
  }
}

window.addEventListener("load", () => {
  new Rating();
});
